import React, { Component } from 'react';
import ParameterErrors from '../errors/ParameterErrors';
import TabInfo from '../ui_core/TabInfo';
import ImageCarousel from './ImageCarousel';
import Urls from '../urls/Urls';
import JumpableZoomableDragable from './JumpableZoomableDragable';
const {throwNotProvided}=ParameterErrors;
export default class PlotMoreInformationGallery extends Component {
	static get _IMAGE_CAROUSEL_ASPECT_RATIO_THRESHOLD(){
		return 1.5;
	}
	constructor(props){
		super(props);
		const {getViewPort, onExpandImage, configuration}=props;
		this._configuration= configuration;
		this._callbackExpandImage = onExpandImage;
		this._getContainerViewPort = getViewPort;
		this._element = React.createRef();
		this._tabInfo = new TabInfo({title:'Gallery', className:'gallery-tab'});
		this._loadRoomImages = this._loadRoomImages.bind(this);
		this.state={site:null, plot:null, images:null};
	}
	get tabInfo(){
		return this._tabInfo;
	}
	load(site, plot){
		this.setState({site:site, plot:plot});
		this._loadRoomImages(site, plot);
	}
	_loadRoomImages(site, plot){
		let images = [];
		plot.rooms.getArray().forEach((room)=>{
			const roomImages=room.images;
			images = images.concat(roomImages);
		});
		this.setState({images:images});
	}
	render(){
		const rootUrl = Urls.getAssetsForSite(this._configuration.siteSlug);
		return this._configuration.scrollablePlotMoreInformationGalleryAndFloorPlansElseSingleJumpableZoomableDragableImages?
		(<ImageCarousel className="plot-more-information-gallery" onExpandImage={this._callbackExpandImage} 
			images={this.state.images} rootUrl={rootUrl}
			aspectRatioThreshold ={PlotMoreInformationGallery._IMAGE_CAROUSEL_ASPECT_RATIO_THRESHOLD} 
			getContainerViewPort={this._getContainerViewPort}  ref={this._element}>
		</ImageCarousel>	
		):
		(<JumpableZoomableDragable className="plot-more-information-gallery"
			images={this.state.images} rootUrl={rootUrl}
			zoomMin={1} zoomMax={4} ref={this._element}>
		</JumpableZoomableDragable>
		);
	}
}
